// The persisted Adyen `reason` text is the source of truth. For older records
// that predate the persisted field, fall back to a small reason-code → text
// map, then to the raw code. Extend as needed — this is intentionally minimal.
const REASON_CODE_TEXT = {
    10.4: 'Fraud — card-absent environment',
    13.1: 'Merchandise/services not received',
    13.2: 'Cancelled recurring transaction',
    13.3: 'Not as described or defective',
    13.5: 'Misrepresentation',
    13.7: 'Cancelled merchandise/services',
    4853: 'Cardholder dispute',
    4855: 'Goods or services not provided',
    4863: 'Cardholder does not recognize'
};
export const reasonText = (reason, chargebackReasonCode) => {
    if (reason && reason.trim().length > 0) {
        return reason;
    }
    if (chargebackReasonCode && REASON_CODE_TEXT[chargebackReasonCode]) {
        return REASON_CODE_TEXT[chargebackReasonCode];
    }
    return chargebackReasonCode ?? '—';
};
